import React, { FC, useCallback } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { PostDeliveryOrderBody } from 'src/interfaces/api/DeliveryOrder';
import Product from './components/Product';
import { Grid } from '@material-ui/core';
import Button from 'src/components/Button';
import { QuoteArticleHardware, QuoteArticleVirtual } from 'src/interfaces/api/Deal';

interface Props {
  virtualArticles: QuoteArticleVirtual[];
  hardwareArticles: QuoteArticleHardware[];
}

const ProductsSection: FC<Props> = ({ virtualArticles, hardwareArticles }) => {
  const { control } = useFormContext<PostDeliveryOrderBody>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'articles',
    keyName: 'fieldId',
  });

  const handleAddArticle = () => {
    append({
      name: '',
      code: '',
      quantity: 0,
      description: '',
      enabled: true,
    });
  };

  const getQuoteArticle = useCallback(
    (quoteId?: string): undefined | QuoteArticleHardware | QuoteArticleVirtual => {
      if (!quoteId) return undefined;

      const article = virtualArticles.find((article) => article.id === parseInt(quoteId, 10));

      if (article) {
        return article;
      }

      return hardwareArticles.find((article) => article.id === parseInt(quoteId, 10));
    },
    [virtualArticles, hardwareArticles]
  );

  return (
    <Grid container spacing={2}>
      {fields.map((product, index) => (
        <Grid item xs={12} key={product.fieldId}>
          <Product
            product={getQuoteArticle(product.code)}
            index={index}
            control={control}
            onRemove={() => remove(index)}
          />
        </Grid>
      ))}

      <Grid item xs={12}>
        <Button variant='text' color='primary' onClick={handleAddArticle}>
          + Ajouter un article
        </Button>
      </Grid>
    </Grid>
  );
};

export default ProductsSection;
